// LIBRARIES

import styled, { css } from "styled-components";
import TextField from "@mui/material/TextField";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";
import { InputAtomTypes } from "./InputAtomModel";
import { Input } from "@mui/material";

export const InputAtom = styled(TextField)(
  ({ isActive, inputType }) => css`
    & .MuiInputBase-root {
      border-color: transparent;
      height: ${inputType === InputAtomTypes.SEARCH ? "40px" : "64px"};
      width: ${inputType === InputAtomTypes.SEARCH ? "468px" : "320px"};
      background-color: #EBEBEB;
      border-radius: 16px;
      font-size: ${inputType === InputAtomTypes.SEARCH ? "16px" : "18px"};
      color: #293462;
      font-family: ${FONTS.poppins};
      font-weight: ${inputType === InputAtomTypes.SEARCH ? "" : "600"};
      display: flex;
      flex-direction: row;
      overflow: hidden;
      padding-left: ${inputType === InputAtomTypes.SEARCH ? "45px" : "60px"};
      padding-top: 5px;
      border: 3px solid ${(isActive && inputType !== InputAtomTypes.SEARCH) ? "#B6B7BF" : "transparent"};
      @media screen and (max-width: 800px) {
        width: ${inputType === InputAtomTypes.SEARCH ? "234px" : "320px"};
      }
    }
    input::placeholder {
      font-size: ${inputType === InputAtomTypes.SEARCH ? "16px" : "18px"};
      color: #B6B7BF;
      font-family: ${FONTS.poppins};
      // font-weight: 600;
      opacity: 1;
    }
    
    
  `
);

export const IconButton = styled.img`
    position: absolute;
    right: 20px;
    z-index: 100;
    cursor: pointer;
    margin-bottom: 5px;
`;

export const SearchIconButton = styled.img`
    position: absolute;
    right: 20px;
    z-index: 100;
    cursor: pointer;
    margin-bottom: 1px;
    width: 12px;
`;

export const IconButtonStart = styled.img`
    position: absolute;
    left: 20px;
    z-index: 100;
    cursor: pointer;
    margin-bottom: 5px;
    // width: 16px
`;

export const SearchIconButtonStart = styled.img`
    position: absolute;
    left: 20px;
    z-index: 100;
    cursor: pointer;
    // margin-bottom: 5px;
    width: 15px;
`;

export const InfoLine = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #EBEBEB;
  padding-bottom: 10px;
  margin-bottom: 24px;
`;

export const Label = styled.div`
font-size: 14px;
color: #B6B7BF;
font-family: ${FONTS.poppins};
letter-spacing: 0.28px;
font-weight: medium;
margin-bottom: 10px;
`;

export const StyledInput = styled(Input)`
  &.MuiInput-root {
    color: #1D1D26;  // Text color
    font-size: 16px;
    font-family: 'Poppins', sans-serif;
    letter-spacing: 0.64px;
    font-weight: 500;
    
    // Remove underline
    &::before, &::after {
      border-bottom: none !important;
    }
  }
  
  // Remove hover and focus effects
  &:hover, &.Mui-focused {
    &.MuiInput-underline::before, &.MuiInput-underline::after {
      border-bottom: none !important;
    }
  }
`;

export const StyledDate = styled.div`
  color: #1D1D26;  // Text color
  font-size: 16px;
  ont-family: 'Poppins', sans-serif;
  letter-spacing: 0.64px;
  font-weight: 500; 
`;
